import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  IProfileEntry,
  IProfileEntryCustomerVehicleLinkOpt,
  IProfileEntryCustomerVehicleLinkOptDtl,
} from '@blcloud/bl-datamodel';
import {
  ProfileEntryResource,
  ProfileEntryCustomerVehicleLinkOptResource,
} from '@blcloud/bl-ng-resource';
import {
  LoginResourceService,
} from '@blcloud/bl-ng-share-module';
import { RoleConst } from '@blcloud/bl-datamodel/const/role';

/**
 * プロフィール登録紐付け画面 ロジックサービス
 */
@Injectable()
export class ProfileMatchingModalService {

  constructor(
    private loginResourceService: LoginResourceService,
    private profileEntryResource: ProfileEntryResource,
    private profileEntryCustomerVehicleLinkOptResource: ProfileEntryCustomerVehicleLinkOptResource,
  ) {
  }

  /**
   * 顧客紐付け実行
   * @param profileEntry プロフィール登録情報
   * @param linkData 紐付対象顧客情報
   * @return 結果ストリーム
   */
  startProfileMatching(profileEntry: IProfileEntry, linkData: IProfileEntryCustomerVehicleLinkOptDtl) {
    const body: IProfileEntryCustomerVehicleLinkOpt = {
      profileRegistNum: profileEntry.profileRegistNum,
      registerYearMonth: profileEntry.registerYearMonth,
      profileEntryCustomerVehicleLinkOptDtlList: [linkData],
    };
    return this.profileEntryCustomerVehicleLinkOptResource.post<IProfileEntryCustomerVehicleLinkOptDtl>(
      body,
      {
        entityOptions: {
          exPath: 'link'
        },
      },
    );
  }

  /**
   * プロフィール登録情報の更新(破棄)
   * @entities ProfileEntry プロフィール登録情報
   */
  startProfileEntryDiscard(entities: IProfileEntry): Observable<any> {
    const body: IProfileEntry[] = [entities];
    return this.profileEntryResource.post<IProfileEntry>(
      body,
      {
        entityOptions: {
          exPath: 'discard'
        },
      },
    );
  }

  /**
   * プロフィール本登録のロールを取得
   */
  isAvailableProfileMainEntryRole(): Observable<boolean> {
    return this.loginResourceService.isAvailableFunction(RoleConst.ROLEID_FUNC_ALL_PROFILE_MAIN_ENTRY);
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-matching-modal/profile-matching-modal.service.ts